import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical, ArrowRight } from "lucide-react";
import { ANALYSIS_DATA } from "../mock";

export default function AnalysisPage() {
  return (
    <div className="bg-[#f4f0e6] text-[#3a3a32] min-h-screen">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-20 pb-12 text-center">
        <p className="text-xs tracking-[0.4em] uppercase text-[#4a7ba1] mb-4">{ANALYSIS_DATA.harvest} Harvest — Certificate of Analysis</p>
        <h1 className="text-4xl md:text-6xl font-light leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          The numbers, independently verified.
        </h1>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-20">
        <div className="grid md:grid-cols-2 gap-6">
          {ANALYSIS_DATA.metrics.map((m, i) => (
            <div key={i} className="bg-[#ece6d6]/60 border border-[#4a7ba1]/20 rounded-sm p-6 flex items-baseline justify-between gap-4">
              <div>
                <div className="text-xs uppercase tracking-widest text-[#4a7ba1]">{m.label}</div>
                <div className="text-3xl md:text-4xl text-[#1e3a52] mt-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{m.value}</div>
              </div>
              <div className="text-sm text-[#5a5a52] text-right">{m.unit}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-8 bg-[#1e3a52] text-[#f4f0e6] rounded-sm">
          <div className="flex items-center gap-3 text-[#d4a857]"><FlaskConical size={20} /><span className="uppercase tracking-widest text-xs">Verified by</span></div>
          <ul className="mt-4 space-y-2 text-[#dcd6c4]">
            {ANALYSIS_DATA.labs.map((l, i) => <li key={i} className="leading-relaxed">• {l}</li>)}
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/waitlist" className="inline-flex items-center gap-2 bg-[#d4a857] hover:bg-[#b8893d] text-[#0f2c44] px-5 py-2.5 rounded-sm font-medium" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "16px" }}>
              Reserve this harvest <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
